<script>
export default {
  name: 'Clients'
}
</script>

<template>
  <!--START CLIENTS-->
      <section class="section-sm bg-light">
        <div class="container">
          <div class="row">
            
            <div class="col-md-6">
              <div class="client-images my-3 my-md-0">
                <img
                  src="@/assets/images/clients/2.png"
                  alt="logo-img"
                  style="width:450px;"
                  class="mx-auto img-fluid d-block"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="client-images my-3 my-md-0">
                <img
                  src="@/assets/images/clients/3.png"
                  alt="logo-img"
                  style="width:450px;"
                  class="mx-auto img-fluid d-block"
                />
              </div>
            </div>

            
          </div>
        </div>
      </section>
  <!--ENd CLIENTS-->
</template>